// Shared scoring constants for challenge solutions (frontend + backend).
//
// See docs/persistence-backend.md — "The Solution Model".

/**
 * Per-unsolved-game penalty AND per-game validity ceiling.
 *
 * A valid solved game must score strictly below cap(N); a missing game scores
 * exactly cap(N), so an unsolved game always loses to any valid solved one.
 * cap(N) = 100 × N².  → 3600 (6×6), 6400 (8×8), 10000 (10×10).
 */
export function cap(size: number): number {
    return 100 * size * size;
}

/** Usernames only the admin/sync path may assign (the reference players). */
export const RESERVED_USERNAMES = ['Quadrant', 'Gyrodiot'] as const;

/** Reserved-name check is case-insensitive. */
export function isReservedUsername(name: string): boolean {
    const lower = name.toLowerCase();
    return RESERVED_USERNAMES.some(r => r.toLowerCase() === lower);
}

export const USERNAME_REGEX = /^[A-Za-z0-9_-]{1,24}$/;

export function isValidUsername(name: string): boolean {
    return USERNAME_REGEX.test(name);
}

/** Zero-penalty Base completions required to unlock the Vortex track. */
export const VORTEX_UNLOCK_COUNT = 3;
